import React from 'react'

const ManufacturerAddPage = React.lazy(() => import('pages/Manufacturer/ManufacturerAddPage'));
const ManufacturerPage = React.lazy(() => import('pages/Manufacturer/ManufacturerPage'));

const ManufacturerRoutes = [
    {
        path: '/manufacturer',
        exact: true,
        name: 'Danh sách hãng',
        function: 'MD_MANUFACTURER_VIEW',
        component: ManufacturerPage,
    },
    {
        path: '/manufacturer/add',
        exact: true,
        name: 'Thêm hãng',
        function: 'MD_MANUFACTURER_ADD',
        component: ManufacturerAddPage,
    },
    {
        path: '/manufacturer/edit/:manufacturer_id',
        exact: true,
        name: 'Chỉnh sửa hãng',
        function: 'MD_MANUFACTURER_EDIT',
        component: ManufacturerAddPage,
    },
    {
        path: '/manufacturer/detail/:manufacturer_id',
        exact: true,
        name: 'Xem hãng',
        function: 'MD_MANUFACTURER_VIEW',
        component: ManufacturerAddPage,
    },
]

export default ManufacturerRoutes
